import { Component, Input } from '@angular/core';
import { CustomerStatus } from '@innogy/customer/store';
import type { InnogyComponentRendering } from '@core/jss-models';
import { getFieldValue } from '@core/jss-utils';
import type { Field } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-mijn-information-block',
  templateUrl: './mijn-information-block.component.html',
  styleUrls: [],
})
export class MijnInformationBlockComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering: InnogyComponentRendering | undefined;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() customerStatus?: CustomerStatus;

  get showCustomerCooldown() {
    return (
      this.customerStatus === CustomerStatus.Cooldown &&
      (
        this.rendering?.fields?.['OnboardingMessage'] as Field<string>
      ).value.trim() !== ''
    );
  }

  get shouldShow() {
    if (this.customerStatus === CustomerStatus.Cooldown) {
      return getFieldValue<boolean>(this.rendering, 'showOnboarding');
    }

    return true;
  }

  get linedTitle() {
    return getFieldValue<boolean>(this.rendering, 'linedTitle');
  }

  get sideNote() {
    return getFieldValue<boolean>(this.rendering, 'sidenote');
  }
}
